<template>
    <main class="login login-page">
      <login-form></login-form>
      <p class="register-desc font-regular">
        {{$t('login.regText')}} <router-link to="register">{{$t('login.regLink')}}</router-link>
      </p>
      <p class="copyright font-regular">OmniIoTh © {{thisYear}}</p>
      <lang-switcher></lang-switcher>
    </main>
</template>

<script>
  import loginForm from '../components/Pages/Login/loginForm'
  import {hideSidebar} from "../mixins/utils/hideSidebar";
  import langSwitcher from '../components/Pages/Login/langCont'

  export default {
    name: 'login',
    mixins: [hideSidebar],
    components: {
      loginForm,
      langSwitcher
    },
    data() {
      return {
        thisYear: new Date().getFullYear()
      }
    },
    mounted() {
    }
  }
</script>

<style lang="scss">

  .login-page {
    text-align: center;
  }

  .register-desc {
    margin-bottom: auto;
    font-size: 14px;
    color: white;

    a {
      text-decoration: underline;
      color: $lightBlue
    }
  }

  .copyright {
    margin-top: auto;
    margin-bottom: 40px;
    color: white;
    opacity: 0.48;
    font-size: 14px;
    letter-spacing: 0.25px;
    padding-top: 50px;
  }
</style>
